export const DefaultIssuer = 'DED';

export const Authorities = [
  { code: 'EID', name: 'Emirates Identity Authority' },
  { code: DefaultIssuer, name: 'Department of Economic Development' },
  { code: 'DET', name: 'Department of Economy & Tourism' },
  { code: 'DMCC', name: 'Dubai Multi Commodities Centre' },
  { code: 'JAFZA', name: 'Jebel Ali Free Zone' },
  { code: 'DAFZ', name: 'Dubai Airport Free Zone' },
  { code: 'DPCFZC', name: 'Dubai Ports and Customs and Free Zone Corporation' },
  { code: 'DSOA', name: 'Dubai Silicon Oasis Authority' },
  { code: 'DTMFZA', name: 'Dubai Technology and Media Free Zone Authority' },
  { code: 'JLT', name: 'Jumeirah Lake Towers' },
  { code: 'DHCC', name: 'Dubai Health Care City' },
  { code: 'DIFC', name: 'Dubai International Financial Center' },
  { code: 'DMC', name: 'Dubai Maritime City' },
  { code: 'DEDAD', name: 'Department of Economic Development - Abu Dhabi' },
  { code: 'PEDAD', name: 'Planning and Economy Department - Abu Dhabi' },
  { code: 'DEDS', name: 'Department of Economic Development – Sharjah' },
  { code: 'HFZAS', name: 'Hamriyah Free Zone Authority – Sharjah' },
  { code: 'SIAFZ', name: 'Sharjah International Airport Free Zone' },
  { code: 'TP', name: 'TechnoPark' },
  { code: 'DWC', name: 'Dubai World Central' },
  { code: 'DTCM', name: 'Department of Tourism and Commerce Marketing' },
  { code: 'AFZA', name: 'Ajman Free Zone Authority' },
  { code: 'AM', name: 'Ajman Municaplity' },
  { code: 'DEDRAK', name: 'Department of Economic Development - Ras Al Khaimah' },
  { code: 'FZARAK', name: 'Free Zone Authority - Ras Al Khaimah' },
  { code: 'FFZ', name: 'Fujairah Free Zone' },
  { code: 'FM', name: 'Fujairah Municapility' },
  { code: 'DEDUAQ', name: 'Department of Economic Development - Umm Al Quwain' },
  { code: 'DCCA', name: 'Dubai Creative Clusters Authority' },
  { code: 'DGD', name: 'Department of the Government of Dubai' },
  { code: 'CDA', name: 'Community Development Authority' },
  { code: 'UALQFTZA', name: 'Umm Al Quwain Free Trade Zone Authority' },
  { code: 'ADAFZ', name: 'Abu Dhabi Airport Free Zone' },
  { code: 'DEDA', name: 'Department of Economic Development-Ajman' },
];
